module.exports = __webpack_public_path__ + "static/media/customcolumns.18dc46fc.md";